module.exports = __webpack_public_path__ + "static/img/present.cd419b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/present.png
// module id = BLDV
// module chunks = 1